import { Box } from "@mui/material";
import { Modal } from "react-bootstrap"; // TODO: Replace with MUI

import CICOPdf from "features/public/Resources/Publications/PublicationPDFs/CCEVSGuidance/CICO.pdf";

import stepThreeImage from "../../assets/step-three.png";

export default function StepThreeModal({ show, setShowStepThreeModal }) {
  const handleClose = () => {
    setShowStepThreeModal(false);
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header className="border-0 pb-0" closeButton></Modal.Header>
      <Modal.Body className="px-5 pt-0">
        <div className="d-flex justify-content-center">
          <img
            src={stepThreeImage}
            alt="step three image"
            className="w-auto"
            height="120px"
          />
        </div>

        <h3 className="text-uppercase text-center fw-bold mb-3 text-primary">
          Step 3
        </h3>

        <h5 className="fw-bold">Evaluation/Check-Out Proceedings</h5>

        <Box
          component="ul"
          className="mt-4"
          sx={{
            pl: 1,
            "& li": { my: "8px" },
            "& li h5": { mt: 3 },
          }}
        >
          <li>
            <h5 className="fw-bold">
              Lab evaluates product and provides all relevant documentation to
              NIAP
            </h5>

            <ul>
              <li>
                Sync sessions may be held between Lab/Validators to answer
                questions & resolve issues
              </li>
              <li>Including NIST Certificate (if required)</li>
            </ul>
          </li>

          <li>
            <h5 className="fw-bold">
              <a href={CICOPdf}>Evaluation Checkout</a>
            </h5>

            <ul>
              <li>
                NIAP Validators review all delivered relevant documentation and
                draft the Validation Report
                <ul>
                  <li>
                    Checkout review is conducted and completed within 10
                    business days of receipt
                  </li>

                  <li>
                    Possibly return to lab for corrections to documentation or
                    clarification. If correction is needed, the validators will
                    have 10 business days to review each resubmission
                  </li>
                </ul>
              </li>

              <li>
                NIST Certificate Review conducted (if required)
                <ul>
                  <li>Possibly return to lab for correction if rejected</li>
                </ul>
              </li>
            </ul>
          </li>

          <li>
            <h5 className="fw-bold">
              NIAP Validators submit final Check-out package approval with
              finalized:
            </h5>

            <ul>
              <li>Security Target</li>
              <li>Evaluation Technical Report</li>
              <li>Assurance Activities Report</li>
              <li>Detailed Test Report</li>
              <li>NIAP End of Evaluation Survey (Form F8004)</li>
              <li>Administrative Guidance</li>
              <li>
                Any additional public guidance documents pertaining to the
                product
              </li>
            </ul>
          </li>

          <li>
            <h5 className="fw-bold">
              NIAP Validators submit the final draft Validation Report to the
              vendor and CCTL for accuracy and release approval
            </h5>
          </li>

          <li>
            <h5 className="fw-bold">
              CCTL and Vendor will review the draft CC Certificate, final draft
              Validation Report, and sign the Release of Information (ROI)
              F8002b form
            </h5>
          </li>

          <li>
            <h5 className="fw-bold">
              Upon completion, NIAP Validators will review and recommend the
              evaluation for posting to the Product Compliant List (PCL) to NIAP
            </h5>
          </li>

          <li>
            <h5 className="fw-bold">
              NIAP reviews the final package and if the evaluation is deemed as
              successful, NIAP will publish the evaluation to the (PCL) within
              three (3) business days
            </h5>
          </li>

          <li>
            <h5 className="fw-bold">Timeline:</h5>

            <ul>
              <li>Target: 90 Days</li>
              <li>Max: 6 Months</li>
            </ul>
          </li>
        </Box>

        <Box my={4}>
          <h5 className="fw-bold text-bright-navy mt-4">
            What is Administrative Guidance
          </h5>

          <p>
            Instructions to users on how to configure the product so that it is
            consistent with the evaluated configuration.
          </p>

          <h5 className="fw-bold text-bright-navy mt-4">
            What is Assurance Activities Report?
          </h5>

          <p>Summarized assurance activities of the product evaluation.</p>

          <h5 className="fw-bold text-bright-navy mt-4">
            What is a Validation Report?
          </h5>

          <p>
            A publicly available document issued by the NIAP validation body
            that summarizes the evaluation results and confirms the overall
            results are acceptable.
          </p>
        </Box>
      </Modal.Body>
    </Modal>
  );
}
